import { Alert, AlertTitle, Stack, Typography } from '@mui/material';

import type { DashboardSummary } from '@/lib/api/dashboard';

interface Props {
  sync: DashboardSummary['sync'];
}

function formatKst(iso: string | null): string {
  if (!iso) return '기록 없음';
  return new Date(iso).toLocaleString('ko-KR', { dateStyle: 'medium', timeStyle: 'short' });
}

/**
 * 동기화·연동 상태.
 *
 * 자정 집계 cron이 멈추면 화면의 모든 숫자가 과거 값으로 굳는데, 화면상으로는
 * 정상처럼 보인다. 보이스웰니스 연동도 degrade 처리를 넣어 끊겨도 화면이 뜨므로
 * 마찬가지다. 두 경우 모두 여기서만 드러난다 — 이상할 때만 눈에 띄게 표시한다.
 */
export function SyncStatusBar({ sync }: Props) {
  const problems: string[] = [];
  if (sync.stale) problems.push('일간 집계가 24시간 넘게 갱신되지 않았습니다');
  if (!sync.voicecheckConnected) problems.push('보이스웰니스 DB에 연결하지 못했습니다');

  if (problems.length === 0) {
    return (
      <Typography variant="caption" color="text.disabled">
        마지막 동기화 {formatKst(sync.lastSyncedAt)} · 보이스웰니스 연동 정상
      </Typography>
    );
  }

  return (
    <Alert severity="warning" variant="outlined">
      <AlertTitle>데이터가 최신이 아닐 수 있습니다</AlertTitle>
      <Stack spacing={0.25}>
        {problems.map((p) => (
          <Typography variant="body2" key={p}>
            • {p}
          </Typography>
        ))}
        <Typography variant="caption" color="text.secondary">
          마지막 동기화 {formatKst(sync.lastSyncedAt)} · 관리자에게 알려주세요.
        </Typography>
      </Stack>
    </Alert>
  );
}
